import { PencilIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import moment from 'moment'

export default function MembershipsTableRow({ membership, isSelected, onSelectMembership }) {

  const formatDate = (dateString) => {
    return moment(dateString).format('YYYY-MM-DD');
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      'active': 'bg-green-100 text-green-800',
      'expired': 'bg-red-100 text-red-800',
      'suspended': 'bg-yellow-100 text-yellow-800',
      'cancelled': 'bg-gray-100 text-gray-800'
    };

    const className = statusClasses[status?.toLowerCase()] || 'bg-gray-100 text-gray-800';

    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>
        {status || 'Unknown'}
      </span>
    );
  };

  const formatUsage = (remaining, total) => {
    // if (!remaining && !total) return 'N/A'
    if (total) {
      return `${remaining || 0}/${total}`
    }
    return remaining;
  };

  return (
    <tr className="hover:bg-gray-100">
      <td className="py-2 px-4 border-b border-gray-300 text-left w-12">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelectMembership(membership._id, e.target.checked)}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
        />
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <Link 
            to={`/memberships/details/${membership._id}`}
            className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
          >
            {membership.customerName || 'N/A'}
          </Link>
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          {membership.type || 'N/A'}
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        {getStatusBadge(membership.status)}
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          {formatUsage(membership.remainingUsage, membership.totalUsage)}
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-black">
          {membership.expiryDate ? formatDate(membership.expiryDate) : 'N/A'}
        </span>
      </td>
    <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
      <Link
        to={`/memberships/edit/${membership._id}`}
        className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-200"
      >
        <PencilIcon className="h-4 w-4" />
        <span>Edit</span>
      </Link>
    </td>
    </tr>
  );
}
